<template>
  <section class="search-bar"><slot></slot></section>
</template>

<script>
export default {
  name: "ArticleFilter",
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
.search-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 15%;
  flex-wrap: wrap;
  background: url("../../assets/images/search/search_bg@2x.png") center
    no-repeat;
  background-size: cover;
  margin-bottom: 45px;
  @include for-tablet {
    padding: 30px 0;
  }
}
</style>
